const reports = {
  "admin.performance-report.download": "Descargar informe",
};

export const admin = {
  ...reports,
};
